import React from "react";

import {BreadCrumbContainer, Root, RootItem} from "./styles";

import {BreadCrumbProps} from "./types";
import {Link} from "@itchannelplus/navigation";
import {VariantProps} from "@phntms/css-components";

export const BreadCrumb = ({items, ...props}: BreadCrumbProps & VariantProps<typeof BreadCrumbContainer>) => {
  return (
    <BreadCrumbContainer {...props}>
      <Root>
        {items.map(({item, onPress}, index) => (
          <RootItem key={`root-item-${index}`} onClick={onPress} >
            {typeof item == 'string' && `${item}${index !== (items.length - 1) ? ' ›' : ''}`}
            {typeof item == 'object' && <Link href={item.href} target={item.target} >{item.label}{index !== (items.length - 1) ? ' ›' : ''}</Link> }
          </RootItem>
        ))}
      </Root>
    </BreadCrumbContainer>
  );
};
